/**
 * url 接口地址
 * @type {string}
 */
// export const url = 'http://10.18.59.162:8080'
export const url = 'https://abzed-portal.lkcgyl.com'
